import React from 'react'
import { Outlet, Navigate } from 'react-router-dom'

function PrivateRoute({isLogged}) {
  return isLogged ? <Outlet /> : <Navigate to="/" />;
}

export default PrivateRoute